import { selectAllUsers } from './usersSlice';

export const selectAllActiveUsers = (state) =>
    Object.values(selectAllUsers(state)).filter((user) => {
        return user.active;
    });
export const selectAllInActiveUsers = (state) =>
    Object.values(selectAllUsers(state)).filter((user) => {
        return !user.active;
    });
